import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import * as React from "react";

import { ThemeProvider } from "@emotion/react";
import createTheme from "@mui/material/styles/createTheme";
import "./Articles.css";
import Main from "../Common/Main";
import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from "@mui/system/useMediaQuery";

const theme = createTheme({
  components: {
    MuiChip: {
      styleOverrides: {
        colorSuccess: {
          borderColor: "rgb(65, 10, 10)",
          color: "rgb(65, 10, 10)",
        },
      },
    },
  },
});

interface Book {
  author: string;
  title: string;
}

interface Article {
  author: string;
  link: string;
  note: string;
  tags: string[];
  related_books?: Book[];
  title: string;
}

const data = require("./articles.json");

export default function Articles(): JSX.Element {
  const theme = useTheme();
  const smBreakPoint = useMediaQuery(theme.breakpoints.up("sm"));
  const articles: Article[] = [...data];
  const tags = new Set<string>();
  const [selectedTags, setSelectedTags] = React.useState<Set<string>>(
    new Set()
  );

  articles.sort((article1, article2) =>
    article1.title.localeCompare(article2.title)
  );

  articles.forEach((article) => article.tags.forEach((tag) => tags.add(tag)));

  return (
    <>
      <Main>
        <Box sx={{ width: "100%" }}>
          <Box
            sx={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}
          >
            {[...tags].map((tag, i) => (
              <ThemeProvider theme={theme} key={i}>
                <Chip
                  color={selectedTags.has(tag) ? "success" : "default"}
                  key={i}
                  label={tag}
                  variant="outlined"
                  onClick={() => {
                    if (selectedTags.has(tag)) {
                      setSelectedTags((current) => {
                        current.delete(tag);
                        return new Set(current);
                      });
                    } else {
                      setSelectedTags((current) => {
                        current.add(tag);
                        return new Set(current);
                      });
                    }
                  }}
                  sx={{
                    m: 0.5,
                    // borderColor: "rgb(65, 10, 10)",
                    fontFamily: "charter",
                  }}
                />
              </ThemeProvider>
            ))}
          </Box>

          <Box className="articles-container">
            {articles
              .filter((article) => {
                if (!selectedTags.size) {
                  return true;
                }

                return [...selectedTags].every((tag) =>
                  article.tags.includes(tag)
                );
              })
              .map((article) => (
                <Card
                  key={article.link}
                  className="article-card"
                  sx={{
                    backgroundColor: "#FFFAFA",
                    boxShadow:
                      "box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;",
                    marginLeft: smBreakPoint ? "10px" : "0px",
                    marginRight: smBreakPoint ? "10px" : "0px",
                    width: smBreakPoint ? "250px" : "100%",
                  }}
                >
                  <span className="card-title">{article.title}</span>
                  <Typography
                    fontFamily={"inherit"}
                    variant="body2"
                    className="author"
                  >
                    By {article.author}
                  </Typography>
                  <div className="divider"></div>
                  {/* <br /> */}
                  <Typography
                    variant="body1"
                    className="personal-note"
                    sx={{ fontFamily: "charter", marginBottom: "20px" }}
                  >
                    {article.note}
                  </Typography>
                  {/* <br /> */}
                  <Typography variant="body2">
                    <Link
                      href={article.link}
                      underline="always"
                      target="_blank"
                      rel="noopener"
                    >
                      Read More
                    </Link>
                  </Typography>
                </Card>
              ))}
          </Box>
        </Box>
      </Main>
    </>
  );
}
